import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "recommendation-treatment",
  "use": "recommendation-treatment-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"recommendation-treatment\">\n<path d=\"M16 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM15 11H11V15H7V11H3V7H7V3H11V7H15V11Z\" fill=\"#263238\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol